"use client"

import { FavoriteList } from "@/features/FavoriteList"

import { Wrapper } from "./_html"


export const FavoriteBox = () => {
    
    return (
        <Wrapper>
            <FavoriteList/>
        </Wrapper>
    )
}